export const SESSION_INACTIVITY_DURATION_PREFERENCE_KEY =
  'session-inactivity-duration'

export const SESSION_INACTIVITY_OPTION_VALUES = ['2h', '12h'] as const

export type SessionInactivityOptionValue =
  (typeof SESSION_INACTIVITY_OPTION_VALUES)[number]

export const DEFAULT_SESSION_INACTIVITY_OPTION: SessionInactivityOptionValue =
  '2h'

export const REMEMBER_ME_MIN_SESSION_INACTIVITY_OPTION: SessionInactivityOptionValue =
  '12h'

const HOUR_IN_MS = 60 * 60 * 1000

export const SESSION_INACTIVITY_TIMEOUTS_MS: Record<
  SessionInactivityOptionValue,
  number
> = {
  '2h': 2 * HOUR_IN_MS,
  '12h': 12 * HOUR_IN_MS,
}

type ResolveSessionInactivityOptionParams = {
  accountPreference?: string | null
  persistSession?: boolean
}

export function normalizeSessionInactivityOptionValue(
  value: string | null | undefined,
): SessionInactivityOptionValue | null {
  if (!value) return null

  return SESSION_INACTIVITY_OPTION_VALUES.includes(
    value as SessionInactivityOptionValue,
  )
    ? (value as SessionInactivityOptionValue)
    : null
}

export function resolveSessionInactivityOptionValue(
  params?: ResolveSessionInactivityOptionParams,
): SessionInactivityOptionValue {
  const accountPreference = normalizeSessionInactivityOptionValue(
    params?.accountPreference,
  )

  if (!params?.persistSession) {
    return accountPreference ?? DEFAULT_SESSION_INACTIVITY_OPTION
  }

  if (!accountPreference) {
    return REMEMBER_ME_MIN_SESSION_INACTIVITY_OPTION
  }

  return SESSION_INACTIVITY_TIMEOUTS_MS[accountPreference] >=
    SESSION_INACTIVITY_TIMEOUTS_MS[REMEMBER_ME_MIN_SESSION_INACTIVITY_OPTION]
    ? accountPreference
    : REMEMBER_ME_MIN_SESSION_INACTIVITY_OPTION
}

export function getSessionInactivityTimeoutMs(
  params?: ResolveSessionInactivityOptionParams,
): number {
  const option = resolveSessionInactivityOptionValue(params)
  return SESSION_INACTIVITY_TIMEOUTS_MS[option]
}
